import React, { useContext, useMemo } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
// import Stack from "react-bootstrap/Stack";
// import { Icon } from "components/Icons";
import { colors, resolveColor, font } from "utils/styles";

import renderItem from "utils/renderItem";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, MARKS, INLINES } from "@contentful/rich-text-types";

export default function TileCardsDisplay(props) {
	const fields = props.data?.fields;

	const isContainer = fields?.isContainer ? fields?.isContainer : false;
	let removeVerticalPadding = fields?.removeVerticalPadding;

	const hashLink = fields?.hashLink;

	const TileCardContent = (props) => {
		return (
			<>
				{documentToReactComponents(props?.tileContent?.fields?.text, {
					renderNode: {
						[BLOCKS.PARAGRAPH]: (node, children) => <p>{children}</p>,
						[BLOCKS.HEADING_6]: (node, children) => <h6>{children}</h6>,

						[BLOCKS.EMBEDDED_ASSET]: (node, children) => {
							return (
								<img src={node.data.target.fields.file.url} alt={node.data.target.fields.description} />
							);
						},
					},
				})}

				<style jsx="true">{`
					h6 {
						font-size: 28px;
						font-weight: bold;
						font-family: ${font.Athelas};
						line-height: 42px;
						color: ${colors.darkBlue};
					}

					p {
						font-size: 17px;
						font-family: "Open Sans";
						line-height: 28px;
						color: ${colors.lightBrown};
					}
				`}</style>
			</>
		);
	};

	const Card = ({ data, index }) => {
		// Memoize grid positioning calculations to prevent unnecessary re-renders
		const gridPositioning = useMemo(() => {
			// 3X3 grid at XL screen size, ["start", "center", "end"] for each row
			const justifyXLMod = (index + 1) % 3;
			const justifyXL =
				justifyXLMod === 1 ? "start" : justifyXLMod === 2 ? "center" : justifyXLMod === 0 ? "end" : "";

			//2X2 grid at Lg screen size, ["end", "start"] for each row
			const justifyMdMod = (index + 1) % 2;
			const justifyMd = justifyMdMod === 1 ? "end" : justifyMdMod === 0 ? "start" : "";

			return { justifyXL, justifyMd };
		}, [index]);

		return (
			<Col
				md={6}
				xl={4}
				className={` justify-content-center justify-content-md-${gridPositioning.justifyMd} justify-content-xl-${gridPositioning.justifyXL} d-flex`}
			>
				<div className="tile m-2 p-5 p-md-4 p-lg-5 p-xl-4  p-xxl-5">
					{/* icon */}
					<img className="pb-4" src={data.fields?.media?.fields?.file?.url} />
					<TileCardContent tileContent={data?.fields?.description} />
					{data?.fields?.contents &&
						data?.fields?.contents.map((content) => {
							return <React.Fragment key={content.sys.id}>{renderItem(content)}</React.Fragment>;
						})}
				</div>
				<style jsx="true">{`
					.tile {
						width: 415px;

						background: ${colors.white};
						border-radius: 2px;
					}
				`}</style>
			</Col>
		);
	};

	return (
		<section id={hashLink} className={`outerWrapper MediaCardSection ${!removeVerticalPadding ? 'with-padding' : ''}`}>
			<Container fluid className={`${isContainer ? `container-${isContainer}` : " "} g-0`}>
				<Row className="g-0 ">
					<Col className="justify-content-center d-flex">
						<div className="tiles ">
							<Row className=" g-0  pb-3 flex-wrap justify-content-center">
								{/* Title */}
								{fields.contents && (
									<Row className={`justify-content-center px-4  text-center g-0`}>
										{fields?.contents.map((component, i) => {
											const model = component?.sys?.contentType?.sys.id;

											const key = component?.sys?.id;

											if (model === "metaTitle") {
												return (
													<React.Fragment key={key}>{renderItem(component)}</React.Fragment>
												);
											} else if (model === "title") {
												return (
													<React.Fragment key={key}>{renderItem(component)}</React.Fragment>
												);
											} else if (model === "content") {
												return (
													<Col key={key} xs={9} lg={7}>
														{renderItem(component)}
													</Col>
												);
											} else {
												return <React.Fragment key={i}></React.Fragment>;
											}
										})}{" "}
									</Row>
								)}
								<Col>
									<Row className="g-0">
										{fields?.mediaCards &&
											fields?.mediaCards.map((card, index) => (
												<Card index={index} key={card.sys.id} data={card} />
											))}
									</Row>
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
			</Container>
			<style jsx="true">{`
				.outerWrapper {
					background: ${resolveColor(fields?.backgroundColor) || colors.lightGray};
				}
				
				.outerWrapper.with-padding {
					padding-top: 2em;
					padding-bottom: 2em;
				}
				
				@media (min-width: 768px) {
					.outerWrapper.with-padding {
						padding-top: 4em;
						padding-bottom: 4em;
					}
				}

				.innerWrapper {
					background: ${resolveColor(fields?.backgroundColor) || colors.lightGray};
				}
				.tiles {
					max-width: 1300px;
				}
			`}</style>
		</section>
	);
}
